import VehiclesError from './VehiclesError.js'

export default class GetMarketedMakesVehiclesError extends VehiclesError {}
